import { api } from './client';

export interface UploadResponse {
  [key: string]: string;
}

export const uploadFile = async (file: File, desiredName?: string): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  if (desiredName) {
    formData.append('desiredName', desiredName);
  }
  const { data } = await api.post<UploadResponse>('/admin/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};

export const uploadVideoFile = async (file: File, desiredName?: string): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  if (desiredName) {
    formData.append('desiredName', desiredName);
  }
  const { data } = await api.post<UploadResponse>('/admin/files/upload/video', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};
